import II18 from '../translate/II18';
import { f7 } from 'framework7-react';

/**
 *
 * @param title
 * @param message
 * @param doYes
 * @param doNo
 * @param yesTitle
 * @param noTitle - '' - hide button | undefined or null - default title
 * @param verticalButtons
 * @param cssClass
 * @param yesCssClass
 * @param noCssClass
 */
export const confirmDialog = (
  title,
  message,
  doYes,
  doNo,
  yesTitle,
  noTitle,
  verticalButtons,
  cssClass,
  yesCssClass,
  noCssClass
) => {
  const buttons = [];
  if (noTitle !== '') {
    buttons.push({
      text: noTitle ? noTitle : II18.get('title_cancel'),
      onClick: doNo,
      cssClass: noCssClass
    });
  }
  buttons.push({
    text: yesTitle ? yesTitle : II18.get('title_yes'),
    onClick: doYes,
    cssClass: yesCssClass || 'main-button'
  });

  f7.dialog
    .create({
      title: title,
      text: message,
      buttons: verticalButtons ? buttons.reverse() : buttons,
      verticalButtons:
        verticalButtons !== undefined ? verticalButtons : !window.isDesktop,
      cssClass: cssClass
    })
    .open();
};

export const alertDialog = message => {
  confirmDialog('', message, undefined, undefined, 'Ok', '');
};
